import { Exception } from "./Exception";
import { ErrorSeverity } from "./ErrorSeverity";

export class InternalServerErrorException extends Exception {
  constructor({
    message,
    response = new Response(null, {
      status: 500,
    }),
    stack,
  }: {
    message: string;
    response?: Response;
    stack?: string;
  }) {
    super({
      errorSeverity: ErrorSeverity.ERROR,
      useErrorBoundary: false,
      name: "InternalServerErrorException",
      message,
      response,
      stack,
    });
  }
}
